import _ from 'underscore';
import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Constants } from '@bingads-webui-theme-2018/theme-fluent';
import { useResponsiveSize } from '@bingads-webui-react/with-responsive-size';
import { MSSupportMenuButton } from '@bingads-webui-react/support-help-options-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { InstrumentationContext } from '@bingads-webui-react/hoc-with-instrumentation';

const getStyles = () => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
    borderLeft: '1px solid #F2F2F2',
  },
  'container-m': {
    '& .ms-support-menu-button-contact-us': {
      fontSize: '12px !important',
    },
  },
  'container-s': {
    '& .ms-support-menu-button-contact-us': {
      fontSize: '12px !important',
    },
  },
});

export const SupportMenuComponent = ({ supportOptions }) => {
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getStyles);
  const displayMode = useResponsiveSize(Constants.ResponsiveSizeBreakpoints);
  const instrumentation = useContext(InstrumentationContext);

  const uiActivity = useMemo(() => {
    if (instrumentation && instrumentation.pmaxLiteSignup) {
      return instrumentation.pmaxLiteSignup.create().supportControl.create();
    }
    return { trace: _.noop, error: _.noop };
  }, [instrumentation]);

  return (
    <div className={classNames('support-container', classes.container, classes[`container-${displayMode}`])}>
      <MSSupportMenuButton
        uiActivity={uiActivity}
        i18n={i18n}
        supportOptions={supportOptions}
      />
    </div>
  );
};

SupportMenuComponent.propTypes = {
  supportOptions: PropTypes.shape({
    IfShowLiveChat: PropTypes.bool,
    RequestCallText: PropTypes.string,
    headerText: PropTypes.string,
    customSupportOptions: PropTypes.shape({
      headerText: PropTypes.string,
      supportOptions: PropTypes.arrayOf(PropTypes.shape({
        text: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.element,
        ]),
        onClick: PropTypes.func,
      })),
    }),
  }).isRequired,
};

export const SupportMenu = () => {
  const serverContext = useContext(ServerContext);

  return (
    <SupportMenuComponent
      supportOptions={serverContext.SupportOptions}
    />
  );
};
